<div class="pdf-overlay">
    <div class="container">
        <div class="btn-container">
            <button (click)="zoomIn()">
                <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM184 296c0 13.3 10.7 24 24 24s24-10.7 24-24V232h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H232V120c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z" />
                </svg>
            </button>
            <button (click)="zoomOut()">
                <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM136 184c-13.3 0-24 10.7-24 24s10.7 24 24 24H280c13.3 0 24-10.7 24-24s-10.7-24-24-24H136z" />
                </svg>
            </button>
            <button (click)="applyZoom(1);convertToPDF()">
                <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                    <path
                        d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" />
                </svg>
            </button>
            <div>
                <button (click)="closePdf()">
                    <svg class="pdf-btn" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                        <path
                            d="M376.6 84.5c11.3-13.6 9.5-33.8-4.1-45.1s-33.8-9.5-45.1 4.1L192 206 56.6 43.5C45.3 29.9 25.1 28.1 11.5 39.4S-3.9 70.9 7.4 84.5L150.3 256 7.4 427.5c-11.3 13.6-9.5 33.8 4.1 45.1s33.8 9.5 45.1-4.1L192 306 327.4 468.5c11.3 13.6 31.5 15.4 45.1 4.1s15.4-31.5 4.1-45.1L233.7 256 376.6 84.5z" />
                    </svg>
                </button>
            </div>
        </div>

        <div class="pdf-container">

            <div id="contentToConvert" #pdfPage>
                <div class="header">
                    <h1>{{pdfVariables.companyDetails.name}}</h1>
                    <h2>New Product Development Job Sheet</h2>
                    <h2>{{pdfVariables.printed}}</h2>
                </div>

                <div class="body">
                    <div class="cus_npd-info">

                        <div class="cus_info">
                            <tr>
                                <th>Customer</th>
                                <td>:</td>
                                <td>{{pdfVariables.customer}}</td>
                            </tr>
                            <tr>
                                <th>Attention To</th>
                                <td>:</td>
                                <td>{{pdfVariables.attentionTo}}</td>
                            </tr>
                        </div>

                        <div class="npd-info">
                            <table>
                                <tr>
                                    <th>NPD No</th>
                                    <td>:</td>
                                    <td>{{pdfVariables.npdNo}}</td>
                                </tr>
                                <tr>
                                    <th>NPD date</th>
                                    <td>:</td>
                                    <td>{{pdfVariables.npdDate}}</td>
                                </tr>
                                <tr>
                                    <th>INQ No</th>
                                    <td>:</td>
                                    <td>{{pdfVariables.inqNo}}</td>
                                </tr>
                                <tr>
                                    <th>Sales P.</th>
                                    <td>:</td>
                                    <td>{{pdfVariables.salesPerson}}</td>
                                </tr>
                                <tr>
                                    <th>Quote No</th>
                                    <td>:</td>
                                    <td>{{pdfVariables.quoteNo}}</td>
                                </tr>
                                <tr>
                                    <th>Due Date</th>
                                    <td>:</td>
                                    <td>{{pdfVariables.dueDate}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div class="job-info">
                        <table>
                            <tr>
                                <th>Job Title</th>
                                <td colspan="3">{{pdfVariables.jobTitle}}</td>
                            </tr>
                            <tr>
                                <th>Material</th>
                                <td colspan="3">{{pdfVariables.material}}</td>
                            </tr>
                            <tr>
                                <th>Order Quantity</th>
                                <td>{{pdfVariables.orderQuantity}}</td>
                                <th>Physical Sample Received</th>
                                <td>{{pdfVariables.sampleReceived}}</td>
                            </tr>
                            <tr>
                                <th>Req. Sample Quantity</th>
                                <td colspan="3">{{pdfVariables.reqSampleQty}}</td>
                            </tr>
                            <tr>
                                <th>Size</th>
                                <td colspan="3">{{pdfVariables.dimention}} {{pdfVariables.dimention_unit}}</td>
                            </tr>
                            <tr>
                                <th>FCS</th>
                                <td>{{pdfVariables.fcs}}</td>
                                <th>Job Completed Date</th>
                                <td>{{pdfVariables.jobCompletedDate}}</td>
                            </tr>
                        </table>
                    </div>

                    <div class="remarks">
                        <h1> <span> Special Finishings: </span> </h1>
                        <p class="pl-5" *ngFor="let f of pdfVariables.finishings"> {{f}}</p>
                        <h1><span>Remarks</span>: {{pdfVariables.remarks}}</h1>
                    </div>

                    <div class="table">
                        <table>
                            <thead>
                                <tr class="h-[20px]">
                                    <th>Description</th>
                                    <th>Quantity</th>
                                    <th>Pack Date</th>
                                    <th>Exp Date</th>
                                    <th>Batch No</th>
                                    <!-- <th>Item No</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of pdfVariables.tblItems">
                                    <td>{{item.description}} </td>
                                    <td>{{item.quantity}} </td>
                                    <td>{{item.packingDate}} </td>
                                    <td>{{item.expieryDate}} </td>
                                    <td>{{item.batchNo}} </td>
                                    <!-- <td>{{item.itemNo}} </td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="bottom">
                        <table>
                            <tr>
                                <th>Winding Direction</th>
                                <td>{{pdfVariables.windingDirection}}</td>
                                <th>No of inner pages</th>
                                <td>{{pdfVariables.book_innerPages}}</td>
                            </tr>
                            <tr>
                                <th>No of ups per reel</th>
                                <td>{{pdfVariables.upsPerReel}}</td>
                                <th>No of cover pages</th>
                                <td>{{pdfVariables.book_coverPages}}</td>
                            </tr>
                            <tr>
                                <th>No of labels per reel</th>
                                <td>{{pdfVariables.lablesPerReal}}</td>
                            </tr>
                            <tr>
                                <th>Core size</th>
                                <td>{{pdfVariables.coreSize}}</td>
                            </tr>
                        </table>
                    </div>
                </div>

                <div class="footer">

                    <div class="w-full flex flex-col">
                        <div class="pb-[3px]">{{pdfVariables.approvals.createdBy}}</div>
                        <hr>
                        <div>Authorized By</div>
                    </div>                    
                    
                    <div class="w-full flex flex-col">
                        <div class="pb-[3px]">{{pdfVariables.approvals.approvedBy}}</div>
                        <hr>
                        <div>Approved By</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>